import CredentialsForm from 'components/CredentialsForm/CredentialsForm';
import { Container } from 'react-bootstrap';

export default function CredentialsPage() {
  return (
    <Container fluid={true}>
      <CredentialsForm />
    </Container>
  );
}
